export default __webpack_public_path__ + "static/media/logo.aab6ce81.png";